<template>
	<page>
		<module title="会员详情">
			<c-detail title="基本信息">
				<c-detail-item label="会员手机号">
					{{baseInfo.user_manage_mobilephone}}
				</c-detail-item>
				<c-detail-item label="会员昵称">
					<span v-if="baseInfo.nick_name && baseInfo.nick_name!=''">
						{{baseInfo.nick_name}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="头像">
                    <c-image :src="baseInfo.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                </c-detail-item>
                <c-detail-item label="用户名">
					<span v-if="baseInfo.login_name && baseInfo.login_name!=''">
						{{baseInfo.login_name}}
					</span>
                    <span v-else>--</span>
                </c-detail-item>
				<c-detail-item label="会员等级">
					<span v-if="baseInfo.user_level_name && baseInfo.user_level_name!=''">
						{{baseInfo.user_level_name}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="业务员">
					<span v-if="baseInfo.salesman_name && baseInfo.salesman_name!=''">
						{{baseInfo.salesman_name}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="注册时间">
					{{baseInfo.create_date}}
				</c-detail-item>
				<c-detail-item label="注册来源">
					{{userResourceMap[baseInfo.user_resource]}}
				</c-detail-item>
				<c-detail-item label="会员状态">
					<span v-if="baseInfo.state == 1" style="color:green">启用</span>
					<span v-if="baseInfo.state == 2" style="color:red">禁用</span>
					<span v-if="baseInfo.state == 3" style="color:blue">待审核</span>
					<span v-if="baseInfo.state == 4" style="color:red">驳回</span>
				</c-detail-item>
				<c-detail-item label="实名认证" full  v-if="systemConfig.f_config_user_auth_enabled =='ON' ">
					<span v-if="baseInfo.auth_state == -1" style="color:#aaa">未认证</span>
					<span v-if="baseInfo.auth_state == 0" style="color:blue">审核中</span>
					<span v-if="baseInfo.auth_state == 1" style="color:green">认证通过</span>
					<span v-if="baseInfo.auth_state == 2" style="color:red">认证驳回</span>
				</c-detail-item>
				<c-detail-item label="业务推荐码" full  v-if="systemConfig.u_config_salesman_code != 1 ">
					<span v-if="extraInfo.salesman_code && extraInfo.salesman_code!=''">
						{{extraInfo.salesman_code}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="注册说明" full v-if="systemConfig.u_config_remark != 1 ">
					<span v-if="extraInfo.remark && extraInfo.remark!=''">
						{{extraInfo.remark}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="审核时间" v-if="baseInfo.state != 3 && systemConfig.user_register_check_enabled == 'ON'">
					<span v-if="baseInfo.approval_date && baseInfo.approval_date!=''">
						{{baseInfo.approval_date}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="审核人" v-if="baseInfo.state != 3 && systemConfig.user_register_check_enabled == 'ON'">
					<span v-if="baseInfo.approval_user_name && baseInfo.approval_user_name!=''">
						{{baseInfo.approval_user_name}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="驳回原因" v-if="baseInfo.state == 4 && systemConfig.user_register_check_enabled == 'ON'" full>
					<span v-if="baseInfo.rejected_reason && baseInfo.rejected_reason!=''">
						{{baseInfo.rejected_reason}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
			</c-detail>
			
			<c-detail title="个人扩展信息" v-if="systemConfig.u_config_user_enabled == 'ON' ">
				<c-detail-item label="姓名" v-if="systemConfig.u_config_realname != 1 ">
					<span v-if="extraInfo.user_realname && extraInfo.user_realname!=''">
						{{extraInfo.user_realname}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="身份证号码" v-if="systemConfig.u_config_idcardno != 1 ">
					<span v-if="extraInfo.idcardno && extraInfo.idcardno!=''">
						{{extraInfo.idcardno}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="身份证照片" v-if="systemConfig.u_config_idcard_img != 1 ">
					<span v-if="extraInfo.idcard_img && extraInfo.idcard_img!=''">
						<c-image v-for="(medias, j) in extraInfo.idcard_img_arr" :key="j" class="img" :src="medias" size="120" preview></c-image>
					</span>
					<span v-else>未上传</span>
				</c-detail-item>
				<c-detail-item label="生日" v-if="systemConfig.u_config_birthday != 1 ">
					<span v-if="extraInfo.birthday && extraInfo.birthday!=''">
						{{extraInfo.birthday}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="性别" v-if="systemConfig.u_config_sex != 1 ">
					<span v-if="extraInfo.sex && extraInfo.sex!=''">
						{{extraInfo.sex}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="固定电话" v-if="systemConfig.u_config_telephone != 1 ">
					<span v-if="extraInfo.telephone && extraInfo.telephone!=''">
						{{extraInfo.telephone}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="E-mail" v-if="systemConfig.u_config_email != 1 ">
					<span v-if="extraInfo.email && extraInfo.email!=''">
						{{extraInfo.email}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="微信" v-if="systemConfig.u_config_wx != 1 ">
					<span v-if="extraInfo.wx && extraInfo.wx!=''">
						{{extraInfo.wx}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="QQ" v-if="systemConfig.u_config_qq != 1 ">
					<span v-if="extraInfo.qq && extraInfo.qq!=''">
						{{extraInfo.qq}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="地址" v-if="systemConfig.u_config_region != 1 || systemConfig.u_config_address != 1">
					<span v-if="extraInfo.user_address_county_name && extraInfo.user_address_county_name!=''">
						{{extraInfo.user_address_province_name}} {{extraInfo.user_address_city_name}} {{extraInfo.user_address_county_name}} {{extraInfo.user_address_address}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
			</c-detail>
			
			<c-detail title="企业信息" v-if="systemConfig.u_config_business_enabled == 'ON' ">
				<c-detail-item label="企业名称" v-if="systemConfig.u_config_company_name != 1 ">
					<span v-if="extraInfo.company_name && extraInfo.company_name!=''">
						{{extraInfo.company_name}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="统一社会信用代码"  v-if="systemConfig.u_config_credit_code != 1 ">
					<span v-if="extraInfo.credit_code && extraInfo.credit_code!=''">
						{{extraInfo.credit_code}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="营业执照"  v-if="systemConfig.u_config_business_licence_img != 1 ">
					<span v-if="extraInfo.business_licence_img && extraInfo.business_licence_img!=''">
						<c-image class="image" :src="extraInfo.business_licence_img" height="120" width="120" preview></c-image>
					</span>
					<span v-else>未上传</span>
				</c-detail-item>
				<c-detail-item label="地址"  v-if="systemConfig.u_config_company_address != 1 ">
					<span v-if="extraInfo.company_address_county_name && extraInfo.company_address_county_name!=''">
						{{extraInfo.company_address_province_name}} {{extraInfo.company_address_city_name}} {{extraInfo.company_address_county_name}} {{extraInfo.company_address_deails}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="法人姓名"  v-if="systemConfig.u_config_legal_person_name != 1 ">
					<span v-if="extraInfo.legal_person_name && extraInfo.legal_person_name!=''">
						{{extraInfo.legal_person_name}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
				<c-detail-item label="法人身份证号码"  v-if="systemConfig.u_config_legal_person_idcardno != 1 ">
					<span v-if="extraInfo.legal_person_idcardno && extraInfo.legal_person_idcardno!=''">
						{{extraInfo.legal_person_idcardno}}
					</span>
					<span v-else>--</span>
				</c-detail-item>
			</c-detail>
			<c-detail>
				<c-detail-item label="注册时间">
					{{baseInfo.create_date}}
				</c-detail-item>
				<c-detail-item label="更新时间">
					<span v-if="extraInfo.create_date">{{extraInfo.create_date}}</span>
					<span v-else>{{baseInfo.create_date}}</span>
				</c-detail-item>
			</c-detail>

			<template slot="button">
				<c-button size="m" v-if="baseInfo.state == 3" @click="applyHandle(1)">审核通过</c-button>
				<c-button size="m" v-if="baseInfo.state == 3" color="red" @click="applyHandle(4)">审核驳回</c-button>
				<c-button size="m" @click="closeCurrPage()">关闭</c-button>
			</template>
		</module>
		
		<c-dialog ref="approvalReason" title="驳回原因" width="400" @resolve="rejectHandle">
		    <div class="approval-eason">
		        <textarea v-model="approvalReason" placeholder="请输入驳回理由..."></textarea>
		    </div>
		</c-dialog>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		name: 'member_detail',

		props: {
			platform_user_id: String
		},

		data() {
			return {
				baseInfo: {},
				extraInfo: {},
				approvalReason: '',
				userResourceMap: {
					'PC': 'PC',
					'OMS': '管理后台',
					'IOS': '苹果APP',
					'ANDROID': '安卓APP',
					'MINI': '微信小程序',
					'BARGAIN': '砍价页',
					'H5': 'H5页'
				}
			}
		},

		computed: {
			...mapState(['systemConfig']),
		},

		watch: {
			platform_user_id() {
				this.getPlatformUserDetail();
			},
		},

		mounted() {
			this.getPlatformUserDetail();
		},

		methods: {
			getPlatformUserDetail() {
				this.request({
					url: '/platform_user/detail',
					data: {
						platform_user_id: this.platform_user_id
					},
					loading: true,
					success: data => {
						this.baseInfo = data.baseInfo;
						this.extraInfo = data.extraInfo;
					}
				});
			},
			applyHandle(state) {
                if(state == 4){
                    this.$refs.approvalReason.open();
                }else{
                    this.$confirm({
                        text: '确定要审批通过吗？',  // 提示内容,
                        buttonName: '确定',  // 确定按钮文字
                        cancelButton: true,  // 是否显示取消按钮
                        resolve: () => {
                            this.request({
                                url: '/platform_user/approval',
                                data: {
                                    platform_user_id: this.platform_user_id,
                                    state
                                },
                                loading: true,
                                success: () => {
                                    this.$message({
                                        text: '审核成功'
                                    });
									this.getPlatformUserDetail();
									this.$bus.$emit('platformApplyList.update');
									this.redirectTo('/member_apply_list');
                                }
                            });
                        },  // 确定按钮回调
                        cancel: () => {},  // 取消按钮回调
                    });
                }


            },
            rejectHandle(stop){
                if (!this.approvalReason.trim()) {
                    this.$message({
                        text: '请填写驳回原因'
                    });
                    stop();
                    return;
                }
                this.request({
                    url: '/platform_user/approval',
                    data: {platform_user_id:this.platform_user_id,state:4,rejected_reason:this.approvalReason.trim()},
                    loading: true,
                    success: data => {
                        this.$message({
                            text: '驳回成功',
                            icon: 'success'
                        });
                        this.getPlatformUserDetail();
						this.$bus.$emit('platformApplyList.update');
                        this.redirectTo('/member_apply_list');
                    }
                });
            },
			closeCurrPage() {
				if(this.baseInfo.state == 3 || this.baseInfo.state == 4){
					this.redirectTo('/member_apply_list');
				}else{
					this.redirectTo('/member_list');
				}
			}
		}
	}
</script>
<style lang="stylus" scoped>
  .approval-eason {
    padding: 20px;

    textarea {
      box-sizing: border-box;
      width: 100%;
      height: 120px;
      border: none;
      padding: 10px 14px;
      line-height: 20px;
      background: #FAFAFA;
      resize: none;
    }
  }
</style>